module.exports = __webpack_public_path__ + "static/media/0-2级标准影像数据规范.0e433b7c.pdf";